export type DealerApiResponseDTO = {
  response_time?: string;
  shield?: string;
};

export type Dealer = {
  id?: string;
  name?: string;
  alt?: string;
  bannerDesktop?: string;
  bannerMobile?: string;
};

export enum SellerShield {
  P = "(P)",
  M = "(M)",
  G = "(G)",
}
